import React from 'react'
import CoopInfoItem from './CoopInfoItem'
import PropTypes from 'prop-types'
import { List } from "@material-ui/core";

const PatientChiefComplaint = ({ mission }) => <List>
        {mission && mission.coopInfo && mission.coopInfo.patient_name
        && <CoopInfoItem
            title={'病人姓名'}
            value={mission.coopInfo.patient_name}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.patient_gender
        && <CoopInfoItem
            title={'性別'}
            value={mission.coopInfo.patient_gender}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.patient_no
        && <CoopInfoItem
            title={'病人身分證字號'}
            value={mission.coopInfo.patient_no}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.birthday
        && <CoopInfoItem
            title={'生日'}
            value={mission.coopInfo.birthday}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.triage
        && <CoopInfoItem
            title={'檢傷分類'}
            value={mission.coopInfo.triage.name}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.type
        && <CoopInfoItem
            title={'會診說明'}
            value={mission.coopInfo.type.name}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.purpose
        && <CoopInfoItem
            title={'會診目的'}
            value={mission.coopInfo.purpose.name}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.icd_code
        && <CoopInfoItem
            title={'病狀臆斷'}
            value={mission.coopInfo.icd_code}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.medical_record_no
        && <CoopInfoItem
            title={'病歷號'}
            value={mission.coopInfo.medical_record_no}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.blood_pressure
        && <CoopInfoItem
            title={'血壓 (mmHg)'}
            value={mission.coopInfo.blood_pressure}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.systolic_blood_pressure
        && <CoopInfoItem
            title={'收縮壓 (mmHg)'}
            value={mission.coopInfo.systolic_blood_pressure}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.diastolic_blood_pressure
        && <CoopInfoItem
            title={'舒張壓 (mmHg)'}
            value={mission.coopInfo.diastolic_blood_pressure}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.body_temperature
        && <CoopInfoItem
            title={'體溫 (°C)'}
            value={mission.coopInfo.body_temperature}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.heart_rate
        && <CoopInfoItem
            title={'脈搏 (bpm)'}
            value={mission.coopInfo.heart_rate}/>
        }
        {mission && mission.coopInfo && mission.coopInfo.respiratory_rate
        && <CoopInfoItem
            title={'呼吸 (rpm)'}
            value={mission.coopInfo.respiratory_rate}/>
        }
        {(mission && mission.vip_note) || ''}
    </List>

PatientChiefComplaint.propTypes = {
    mission: PropTypes.object,
}

export default PatientChiefComplaint



// WEBPACK FOOTER //
// ./src/components/PatientChiefComplaint.js